import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import FrontendLayout from "../../components/frontend/FrontendLayout";

const About: React.FC = () => {
  useEffect(() => {
    const counters = document.querySelectorAll<HTMLElement>(".counter");
    let started = false;
    const duration = 2000; // total animation duration in ms

    const animateCounter = (
      el: HTMLElement,
      target: number,
      startTime: number
    ) => {
      const now = performance.now();
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      el.innerText = Math.floor(progress * target).toString();

      if (progress < 1) {
        requestAnimationFrame(() => animateCounter(el, target, startTime));
      } else {
        el.innerText = `${target}+`;
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !started) {
          const startTime = performance.now();
          counters.forEach((counter) => {
            const targetAttr = counter.getAttribute("data-target");
            const target = targetAttr ? +targetAttr : 0;
            requestAnimationFrame(() =>
              animateCounter(counter, target, startTime)
            );
          });
          started = true;
        }
      },
      {
        threshold: 0.5,
      }
    );

    const section = document.querySelector("#counter-section");
    if (section) {
      observer.observe(section);
    }

    // Clean up observer on unmount
    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <FrontendLayout>
      <section
        className="flat-title style-2 mb-4 tf-spacing-1 inner-banner inner-banner"
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>About us</li>
                </ul>
                <h5 className="mt-3">About us</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-box-team style-2 tf-spacing-1 pb-0">
        <div className="tf-container tf-spacing-1 pt-0">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-inner">
                <div className="heading-section mb-27">
                  <p className="text-1">Who We Are</p>
                  <h2 className="title split-text effect-right">
                    Perfect Place for Plot Search
                  </h2>
                </div>
                <div
                  className="content mb-48 wow animate__fadeInUp animate__animated"
                  data-wow-duration="1s"
                  data-wow-delay="0s"
                >
                  <p className="text-1 description-1 mb-16">
                    Our team of real estate professionals have helped hundreds
                    of buyers, sellers and investors make decisions that they
                    feel were and continue to be right for them years down the
                    road. We measure success not by the sales volume that ranks
                    us among the top 1% of local agents, but by delivering
                    results and fulfilling the trust placed on us by clients.
                  </p>
                  <p className="description-2 text-1 mb-24">
                    We stand ready to serve you as your California real estate
                    team.
                  </p>
                </div>
                <div className="wrap-counter" id="counter-section">
                  <div className="counter-item style-2">
                    <div className="count">
                      <div className="icons">
                        <i
                          className="fas fa-border-style"
                          style={{ fontSize: "4rem" }}
                        ></i>
                      </div>
                      <div className="counter-box">
                        <div className="counter" data-target="900">
                          0
                        </div>
                        <div className="counter-label">Lands for Sale</div>
                      </div>
                    </div>
                  </div>
                  <div className="counter-item style-2">
                    <div className="count">
                      <div className="icons">
                        <i
                          className="fas fa-user"
                          style={{ fontSize: "4rem" }}
                        ></i>
                      </div>
                      <div className="counter-box">
                        <div className="counter" data-target="30">
                          0
                        </div>
                        <div className="counter-label">Expert Agents</div>
                      </div>
                    </div>
                  </div>
                  <div className="counter-item style-2">
                    <div className="count">
                      <div className="icons">
                        <i
                          className="fas fa-check-circle"
                          style={{ fontSize: "4rem" }}
                        ></i>
                      </div>
                      <div className="counter-box">
                        <div className="counter" data-target="400">
                          0
                        </div>
                        <div className="counter-label">Properties Sold</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="wrap-image relative">
                <div
                  className="image-wrap hover-img-wrap img-1 animate__zoomIn wow animate__animated"
                  data-wow-duration="2s"
                >
                  <img
                    className="lazyload parallax-img"
                    data-src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/section-box-team.jpg`}
                    src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/section-box-team.jpg`}
                    alt=""
                  />
                </div>
                <div
                  className="image-wrap hover-img-wrap img-2 animate__zoomIn wow animate__animated"
                  data-wow-duration="2s"
                >
                  <img
                    className="lazyload parallax-img"
                    data-src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/section-box-team-2.jpg`}
                    src={`${process.env.REACT_APP_STATIC_BASE_URL}/frontend/images/section-box-team-2.jpg`}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-why">
        <div className="tf-container tf-spacing-1">
          <div className="row">
            <div className="col-12">
              <div className="heading-section mb-48 text-center">
                <h2 className="title split-text effect-right">
                  Why Choose Us?
                </h2>
                <p className="text-1 split-text split-lines-transform">
                  Here’s just a few reasons why customers are choosing My
                  LandMart to buy their lands.
                </p>
              </div>
              <div className="tf-grid-layout lg-col-4 sm-col-2 mb-46">
                <div className="icons-box effec-icon style-2 p-5 sec1">
                  <div className="tf-icon">
                    <i className="fas fa-calendar text-8"></i>
                  </div>
                  <h5 className="title">
                    <Link to="#">30+ Years of Local Property Experience</Link>
                  </h5>
                  <p className="text-1">
                    We are not loud, noisy and full of our own self-importance.
                    As your agent we know we work for you.
                  </p>
                </div>
                <div className="icons-box effec-icon style-2 p-5 sec2">
                  <div className="tf-icon">
                    <i className="fas fa-smile text-8"></i>
                  </div>
                  <h5 className="title">
                    <Link to="#">
                      We Have <br />
                      Happy Clients
                    </Link>
                  </h5>
                  <p className="text-1">
                    Not all agents have the skills or experience to ensure you
                    get the highest price for your property. Our experience is
                    your guarantee of best price.
                  </p>
                </div>
                <div className="icons-box effec-icon style-2 p-5 sec3">
                  <div className="tf-icon">
                    <i className="fas fa-handshake text-8"></i>
                  </div>
                  <h5 className="title">
                    <Link to="#">We Are not Like Other Agents You Know</Link>
                  </h5>
                  <p className="text-1">
                    We are not loud, noisy and full of our own self-importance.
                    As your agent we know we work for you.
                  </p>
                </div>
                <div className="icons-box effec-icon style-2 p-5 sec4">
                  <div className="tf-icon">
                    <i className="fas fa-lightbulb text-8"></i>
                  </div>
                  <h5 className="title">
                    <Link to="#">Intimate Local Knowledge</Link>
                  </h5>
                  <p className="text-1">
                    Not all agents have the skills or experience to ensure you
                    get the highest price for your property. Our experience is
                    your guarantee of best price.
                  </p>
                </div>
              </div>
              <p className="text-1 text-center mb-48">
                You can obtain more information and an appraisal of your
                property by <Link to="#">clicking this link</Link> now.
              </p>
              <Link
                to="/contact-us"
                className="tf-btn bg-color-primary pd-3 fw-6 mx-auto"
              >
                Get Started Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </FrontendLayout>
  );
};

export default About;
